@import '../framework/ui-cms-sticky-toolbar/ui-cms-sticky-toolbar-item-standard/ui-cms-sticky-toolbar-item-standard';

ui-cms-contact-channels-miscellaneous-sticky-toolbar {
  @include toolbar-channel_contactbox();

  sd-button {
    margin-top: 1.5rem;
  }

  .sd-headline {
    margin-bottom: 0.5rem;
  }
}

.hydrated ~ ui-cms-contact-channels-miscellaneous-sticky-toolbar {
  margin-top: 24px;
}
